import React from "react";
import skills from "../assets/images/rocket.svg";
const Skills = () => {
  return (
    <div className="bg-black w-full p-5">
      <h1 className="text-center text-white  pt-3 font-medium text-xl">
        Skills
      </h1>
      <div className="grid sm:grid-cols-2 items-center">
        <div className="mb-3 p-5 sm:ml-10 lg:ml-32">
          <img src={skills} alt="" className=" sm:h-56 animate-bounce" />
        </div>
        <div className="p-3 sm:ml-20 sm:w-3/4  pb-5 ">
          <h1 className="text-lg text-gray-300 ">JavaScript</h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">HTML/CSS</h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">ReactJs</h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">Python</h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">Python django framework</h1>
          <div className="w-3/4	 bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">
            SQL{" "}
            <span className="text-sm tracking-wider">(PostgreSQL, MySQL)</span>{" "}
          </h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">PERN stack</h1>
          <div className="w-full bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
          <h1 className="text-lg text-gray-300 ">NodeJs</h1>
          <div className="w-3/4	 bg-blue-600 mb-3 h-3.5 rounded-sm">.</div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
